import { styled } from '@grupoboticario/flora-react-system'
import { StyledInternalPlaceholder, StyledLabel } from '../Label/styles'

export const FocusWrapper = styled('div', {
  position: 'relative',
  width: '100%',

  variants: {
    labelPosition: {
      internal: {},
      external: {},
    },
    hasValue: {
      true: {},
    },
    hasEffect: {
      true: {},
    },
    surfaceColor: {
      light: {
        color: '$nonInteractiveAuxiliar',
      },
      dark: {
        '&:placeholder': {
          color: '$nonInteractiveAltAuxiliar',
        },
      },
    },
  },

  compoundVariants: [
    {
      labelPosition: 'internal',
      hasEffect: true,
      css: {
        '&:focus-within': {
          label: {
            fontSize: '$auxiliar',
            lineHeight: '$none',

            [`${StyledInternalPlaceholder}`]: {
              opacity: '0',
            },
          },
        },

        [`${StyledLabel}`]: {
          '&:hover:not(:focus-within), &:not(:hover)': {
            '&:before': {
              top: '2px',
            },
          },
        },
      },
    },
    {
      labelPosition: 'internal',
      hasValue: true,
      css: {
        label: {
          fontSize: '$auxiliar',
          lineHeight: '$none',

          [`${StyledInternalPlaceholder}`]: {
            opacity: '0',
          },
        },
      },
    },
  ],
})
